import React from 'react';
import PropTypes from 'prop-types';

import MainContentHolder from '../MainContentHolder';
import './Promo.css';

const styles = {
  flexBox: {
    display: 'flex',
  },
}

const Promo = ({children, sideContent, title, subtitle}) => (
  <MainContentHolder title={title} subtitle={subtitle}>
    <div style={styles.flexBox}>
      <div className="PromoContentMain">
        {children}
      </div>
      <div className="PromoContentSide">
        {sideContent}
      </div>
    </div>
  </MainContentHolder>
)

Promo.propTypes = {
  title: PropTypes.any,
  subtitle: PropTypes.any,
  children: PropTypes.any,
  sideContent: PropTypes.any,
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/Promo/index.jsx